import classNames from "classnames";
import { CloseIcon } from 'svgIcon';
import { EcommerceFlow } from 'utils/helper';
import AddressFormComponent from "components/AddressFormComponent";
import ECAShippingComponent from "../ECAShippingComponent";
import { FormTypeBilling, FormTypeShipping } from 'components/Ecommerce/ECTheme/ECAddressComponent/constant';
import { useStyles } from './style';

const ECABillingComponent = ({
  setShowShippingLayout,
  form,
  isBothSame,
  onChange,
  formData,
  setFormData,
  errors,
  setErrors,
  nextForm,
  nextFormData,
  setNextFormData,
  itemList,
  grandTotal,
  onCheckout,
  onBtnLoader,
}: any) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.ecAddressWrapper)}>
      <div className="ecAddressTitleWrapper">
        <p className="mainHeading m0">Checkout</p>
        <p onClick={() => setShowShippingLayout(false)} className="cursorPointer"><CloseIcon /></p>
      </div>
      <div className="ecAddressContentWrapper">
        <div className="ecBillingWrapper padd30 radius10 boxShadow">
          <p className="subHeading">Shipping Details</p>
          <AddressFormComponent
            formData={form}
            formType={FormTypeShipping}
            isBothSame={isBothSame}
            onChange={onChange}
            initialValues={formData}
            setInitialValues={setFormData}
            errors={errors}
            setErrors={setErrors}
            flowName={EcommerceFlow}
          />
          {!isBothSame && (
            <>
              <p className="subHeading mt-30">Billing Details</p>
              <AddressFormComponent
                formData={nextForm}
                formType={FormTypeBilling}
                isBothSame={isBothSame}
                onChange={onChange}
                initialValues={nextFormData}
                setInitialValues={setNextFormData}
                errors={errors}
                setErrors={setErrors}
                flowName={EcommerceFlow}
              />
            </>
          )}
        </div>
        <ECAShippingComponent
          itemList={itemList}
          grandTotal={grandTotal}
          onCheckout={onCheckout}
          onBtnLoader={onBtnLoader}
        />
      </div>
    </div>
  );
};

export default ECABillingComponent;
